export default "__VITE_ASSET__BQ7J6sSv__"